import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { additionalAdvisorsSet, settingSet } from 'Global/Stores/auth'
import { settingsModalHide } from 'Global/Stores/modals'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    advisorOptions: selectors.advisorOptions(state),
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    close: () => dispatch(settingsModalHide()),
    setSetting: (setting, value, user) => dispatch(settingSet(setting, value, user)),
    setAdditionalAdvisors: (additionalAdvisors, userId) => dispatch(additionalAdvisorsSet(additionalAdvisors, userId)),
  })

  Enhancer.displayName = 'SettingsModalEnhancer'

  Enhancer.propTypes = {
    advisorOptions: PropTypes.array.isRequired,
    close: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    setAdditionalAdvisors: PropTypes.func.isRequired,
    setSetting: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
